import { useEffect, useRef } from 'react';

/**
 * After tab sleep/wake, clear stuck loading flags so buttons and spinners cannot stay dead forever.
 * Pass setters for any boolean "loading" state that should not survive a long background period.
 * @param {() => void} resetFn
 */
export function useResumeLoadingReset(resetFn) {
  const resetRef = useRef(resetFn);
  resetRef.current = resetFn;

  useEffect(() => {
    const run = () => {
      if (document.visibilityState !== 'visible') return;
      try {
        resetRef.current();
      } catch (_) {
        /* ignore */
      }
    };
    window.addEventListener('online', run);
    window.addEventListener('focus', run);
    document.addEventListener('visibilitychange', run);
    return () => {
      window.removeEventListener('online', run);
      window.removeEventListener('focus', run);
      document.removeEventListener('visibilitychange', run);
    };
  }, []);
}
